import PhaserGame from "..";
import { GameEvents } from "../utils/Types";
import { BaseItem } from "./BaseItem";

export class InventoryManager<
  ItemDataType extends BaseItem,
  ItemKey extends string,
> {
  private _freeSpaces = this.maxInventorySize;
  get freeSpaces(): number {
    return this._freeSpaces;
  }

  constructor(
    public items: (ItemDataType | null)[],
    public readonly maxInventorySize: number,
    private readonly inventoryUpdateEvent: GameEvents,
    private readonly itemData: { [key in ItemKey]: ItemDataType } = {} as {
      [key in ItemKey]: ItemDataType;
    },
  ) {}

  public AddItemToInventory(itemKey: ItemKey): void {
    if (this._freeSpaces <= 0) {
      console.warn("No free inventory space!");
      return;
    }

    const itemData = {
      ...this.itemData[itemKey],
      uniqueId: "item_hash_" + this.freeSpaces + Date.now(),
      effects: this.itemData[itemKey].effects?.map((e) => e.Clone()),
    };

    let inserted = false;
    if (this.items.length > 0) {
      for (let i = 0; i < this.items.length; i++) {
        if (this.items[i] === null) {
          this.items[i] = itemData;
          inserted = true;
          break;
        }
      }
    }

    if (!inserted) this.items.push(itemData);
    this._freeSpaces--;
    PhaserGame.game?.events.emit(this.inventoryUpdateEvent);
  }

  public RemoveItemFromInventory(uniqueId: string): void {
    const index = this.items.findIndex((item) => item?.uniqueId === uniqueId);
    if (index !== -1) {
      this.items[index] = null;
      this._freeSpaces++;
      PhaserGame.game?.events.emit(this.inventoryUpdateEvent);
    }
  }
}
